import { z } from 'zod';

export const RoadmapStatusFilterSchema = z.enum([
  'all',
  'DRAFT',
  'CONFIRMED',
  'ARCHIVED',
]);
export type RoadmapStatusFilter = z.infer<typeof RoadmapStatusFilterSchema>;

export const RoadmapTableFilterSchema = z.object({
  freeText: z.string().optional(),
  productId: z.string().optional(),
  // デフォルトは「最新」(CONFIRMED) タブ
  status: RoadmapStatusFilterSchema.catch('CONFIRMED').default('CONFIRMED'),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
});
